export class Evaluation {
  account = '';
  rate;
  date = new Date().toISOString().split('T')[0];
  description = '';
}